import template from './sw-cms-block-image-four-column.html.twig';
import './sw-cms-block-image-four-column.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
